import styled from 'styled-components';
import {
  typography,
  size,
  colors,
  mediaQueries,
  Dropdown as RawDropdown,
  Input as RawInput,
  TextArea as RawTextArea,
  Button as RawButton,
  Container as RawContainer,
} from '@everlywell/leaves';
import { IFrame as RawIFrame } from 'components/ContactUsPage/styles';

export const Dropdown = styled(RawDropdown)`
  margin-bottom: 6px;
`;

export const Input = styled(RawInput)`
  margin-bottom: 6px;
`;

export const TextArea = styled(RawTextArea)`
  margin-bottom: ${size.lg}px;

  textarea {
    min-height: 199px;
  }
`;

export const Button = styled(RawButton)`
  width: 100%;
`;

export const Headline = styled.h2`
  ${typography.h1Text};
  font-weight: ${typography.weight.bold};
  font-size: 37px;
  line-height: 44px;
  letter-spacing: -0.6px;
  margin-bottom: ${size.lg}px;
`;

export const Description = styled.p`
  ${typography.bodyTextSmall};
  line-height: 26px;
  margin-bottom: ${size.lg}px;
  a {
    font-weight: ${typography.weight.bold};
    color: ${colors.teal4};
    text-decoration: none;

    &:hover {
      color: #008287;
    }
  }
`;

export const Container = styled(RawContainer)`
  position: relative;
  overflow: hidden;
  padding-bottom: 950px;

  @media screen and (min-width: 451px) and (max-width: 515px) {
    padding-bottom: 1050px;
  }

  @media screen and (max-width: 450px) {
    padding-bottom: 950px;
  }
`;

export const IFrame = styled(RawIFrame)`
  ${mediaQueries.forDesktopUp} {
    padding: 0 32px;
    left: 194px;
  }
`;
